import { Injectable, Inject } from 'ng-metadata/core';
import { loadCSS, loadScript, loadScriptWithModuleType } from './scriptLoader';
import {ConfigurationUtil} from "./nddUtils/configurationUtil.service";

const injector = angular.injector(['ng']);
const $q: ng.IQService = injector.get('$q');

const { once, clone,get } = require("lodash");


@Injectable()
export class DigitalPdfStartService {

	private isNewPdfEnabled: boolean;

	constructor( 
         @Inject('$state') private $state: ng.ui.IStateService,
		private configurationUtil: ConfigurationUtil,
         @ Inject('$q') private $q: ng.IQService) {
		      this.isNewPdfEnabled = this.configurationUtil.getFeatureFlag('new_pdfjs');
		}

	public loadPDFCSSAndJavascript() {
		if (this.isNewPdfEnabled) {
			let p1 = this.loadCss("lib/bower_components/pdfjs-viewer/newPdfjs/web/viewer.css");
			let p2 = this.loadJsWithModuleType("lib/bower_components/pdfjs-viewer/newPdfjs/web/viewer.js");
			return this.$q.all([p1,p2]);
		} else {
			let p1 = this.loadCss("lib/bower_components/pdfjs-viewer/viewer.css");
			let p2 = this.loadJs("lib/bower_components/pdfjs-viewer/pdf.js");
			return this.$q.all([p1,p2]);		
		}
	}   
    // methods to load PDF.js and viewer.css dynamically
    		
	private loadJs(jsFile) {
	    let deferred = this.$q((resolve)=> {
	        if(jsFile) {
	            loadScript(jsFile).then(
	                ()=> resolve(true),
	                ()=> resolve(false)
	            );
	        }
	        else {
	            resolve(false);
	        }
	
	
	    });
		return deferred;
	}
	
	private loadJsWithModuleType(jsFile) {
	    let deferred = this.$q((resolve)=> {
	        if(jsFile) {
	            loadScriptWithModuleType(jsFile).then(
	                ()=> resolve(true),
	                ()=> resolve(false)
	            );
	        }
	        else {
	            resolve(false);
	        }
	
	
	    });
		return deferred;
	}
	
	private loadCss(cssFile) {
	let myinstance = this;
	    let deferred = this.$q((resolve)=> {
	    if(cssFile) {
	            loadCSS(cssFile).then(
	                ()=> resolve(true),
	                ()=> resolve(false)
	            );
	        }
	        else {
	            resolve(false);
	        }
	
	
	    });
		return deferred;
	}
	
	
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/digitalPdfStart.service.ts